import { Step, StepIcon, StepIndicator, StepNumber, Stepper, StepperProps, StepSeparator, StepStatus, StepTitle } from '@chakra-ui/react';
import IconArrowRight from 'assets/icons/icon-arrow-right.svg?react';
import { useStepperContext } from './CustomStepperContext';

export default function CustomStepper(props: Omit<StepperProps, 'index' | 'children'>) {
  const { activeStep, steps } = useStepperContext();
  
  return (
    <Stepper 
      ml="auto" 
      {...props}
      index={activeStep}
    >
    {steps.map((step, index) => {
      return (
        <Step 
          key={index}
        >
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>
  
          <StepTitle whiteSpace="nowrap">{step}</StepTitle>
  
          <StepSeparator>
            <IconArrowRight />
          </StepSeparator>
        </Step>
      )
    })}
    </Stepper>
  )
}
